import React, { useState } from 'react';
import './Contact.css';

const Contact = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        message: ''
    });

    const [successMessage, setSuccessMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');

    // Handle Input Changes
    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    // Form Validation
    const validateForm = () => {
        const { name, email, message } = formData;
        if (!name || !email || !message) {
            setErrorMessage('All fields are required.');
            return false;
        }
        if (!/\S+@\S+\.\S+/.test(email)) {
            setErrorMessage('Please enter a valid email address.');
            return false;
        }
        setErrorMessage('');
        return true;
    };

    // Handle Form Submission
    const handleSubmit = (e) => {
        e.preventDefault();
        if (validateForm()) {
            // Placeholder for form submission logic (e.g., send to an API)
            setSuccessMessage('Thank you for reaching out! We will get back to you soon.');
            setFormData({ name: '', email: '', message: '' });
        }
    };

    return (
        <div className="contact-container">
            <h1 className="contact-title">Contact Us</h1>
            <p>If you have any questions, feel free to reach out to us!</p>

            {/* Contact Form */}
            <form className="contact-form" onSubmit={handleSubmit}>
                <input
                    type="text"
                    name="name"
                    placeholder="Your Name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                />
                <input
                    type="email"
                    name="email"
                    placeholder="Your Email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                />
                <textarea
                    name="message"
                    placeholder="Your Message"
                    value={formData.message}
                    onChange={handleChange}
                    required
                ></textarea>
                <button type="submit">Submit</button>
            </form>

            {/* Success and Error Messages */}
            {successMessage && <div className="success-message">{successMessage}</div>}
            {errorMessage && <div className="error-message">{errorMessage}</div>}

            {/* Email Contact Section */}
            <div className="email-contact">
                <p>If you prefer, you can also reach us via email at:</p>
                <a href="mailto:info@ninjabakers.com" className="email-link">info@ninjabakers.com</a>
            </div>
        </div>
    );
};

export default Contact;
